import React, { Component } from 'react'
import { t } from 'i18n'
import { subscribeToToasts } from '../../files/toasts'

const AUTOHIDE_DELAY = 5000

const ICONS = {
  success: 'fa-check-circle',
  danger: 'fa-exclamation-circle',
  info: 'fa-info-circle'
}

class Toasts extends Component {
  state = { toasts: [] }
  nextId = 0

  componentDidMount() {
    this.unsubscribe = subscribeToToasts(this.addToast)

    const { flashText, flashError } = this.props
    this.addToast({ text: flashText, type: flashError ? 'danger' : 'success' })
  }

  componentWillUnmount() {
    this.unsubscribe()
  }

  addToast = ({ text, type }) => {
    if (!text) return

    const id = this.nextId++
    this.setState(({ toasts }) => ({ toasts: [...toasts, { id, text, type }] }))

    // Errors do not autohide
    if (type !== 'danger') setTimeout(() => this.removeToast(id), AUTOHIDE_DELAY)
  }

  removeToast = (id) => {
    this.setState(({ toasts }) => ({ toasts: toasts.filter(toast => toast.id !== id) }))
  }

  render() {
    return (
      <div className='toast-container position-fixed end-0 p-3' aria-live='polite'>
        {this.state.toasts.map(({ id, text, type }) => (
          <div key={id} className={`toast show toast-${type}`} role={type === 'danger' ? 'alert' : 'status'} aria-atomic='true'>
            <div className='d-flex align-items-start'>
              <div className='toast-body d-flex align-items-baseline flex-grow-1'>
                <i className={`fa ${ICONS[type]} me-2`} aria-hidden='true' />
                {text}
              </div>
              <button type='button' className='btn-close m-2' aria-label={t('components.notice.close')} onClick={() => this.removeToast(id)} />
            </div>
          </div>
        ))}
      </div>
    )
  }
}

export default Toasts
